
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["h-4 w-4 text-grey-600",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","class":"h-4 w-4 text-grey-600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M.249 22.293l5.969-5.969a10.016 10.016 0 111.414 1.414l-5.97 5.969A1 1 0 01.25 22.293zM13.956 18a8 8 0 10-8-8 8.009 8.009 0 008 8z"}})])
          )
        }
      }
    